/**
 * API接口配置常量定义
 */

export const API_CATEGORIES = {
  AUTH: '认证授权',
  SPACE: '空间管理',
  TAG: '标签管理',
  COORDINATE: '坐标管理',
  DISPLAY: '显示配置',
  DRAWING: '图纸管理',
  MARKER: '标记管理',
  UPLOAD: '文件上传',
  SERVICE: '服务接口'
} as const;

